import styled from 'styled-components';

export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const LargeButton = styled.button`
  width: 98%;
  margin: 10px auto;
  padding: 10px;
`;

export const FormLabel = styled.label`
 color: white;
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 10px;

  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    color: white;
  }

  textarea {
    font-size: 16px;
  }
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  }

  h1 {
    text-align: center;
    font-size: 12px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 16px;
    margin-top: 15px;
  }
`;


export const ContentRowSingleCol = styled.div`
  margin: 40px 0 65px;

  }

  h1 {
    text-align: center;
    font-size: 15px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 16px;
    margin-top: 15px;
  }
`;

export const InputWrapper = styled.div`
  margin: 40px 0 65px;
  font-size: 16px;

  }
`;



// WEBPACK FOOTER //
// ./src/pages/Admin/SystemVariables/ListVariables/ListVariables.styles.ts